/* v3 nav — the mobile panel toggle, and nothing else.
   The bag button is handled by v3-cart.js, which already listens for
   [data-v3-cart-open] anywhere on the page. */
(function () {
  'use strict';
  function close(returnFocus) {
    var panel = document.querySelector('[data-v3-mnav][data-open]');
    if (!panel) return false;
    panel.removeAttribute('data-open');
    var t = document.querySelector('[data-v3-nav-toggle]');
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      /* Focus goes back to the control that opened it, or it lands on <body>
         and a keyboard user has to tab from the top of the page again. */
      if (returnFocus) t.focus();
    }
    return true;
  }

  /* The cross inside the panel. Yash's review, 15 September: Escape worked but
     was not discoverable, and the live menu has a cross. Delegated, so it costs
     nothing on the pages that have no panel. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-v3-nav-close]')) return;
    close(true);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v3-nav-toggle]');
    if (!btn) return;
    var panel = document.querySelector('[data-v3-mnav]');
    if (!panel) return;
    var open = panel.hasAttribute('data-open');
    if (open) { panel.removeAttribute('data-open'); }
    else { panel.setAttribute('data-open', ''); }
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  // Escape closes it, matching the cart drawer's behaviour.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    close(true);
  });
}());
